// The team room's week plan (course_team_rooms/_plan): the picker's save bar.
//
// - A tick past the limit the form declares (data-plan-limit) is undone, and
//   the bar says why (data-plan-full), rather than a fourth line being quietly
//   dropped on save.
// - The bar's count follows the ticks, and once anything has changed it says
//   the ticks are not saved yet (data-plan-unsaved): a box ticked and left is
//   the mistake the bar exists to prevent.
//
// Every sentence is the server's (CourseTeams::Room), read off the form. The
// server keeps the same cap (CourseTeamRoomsController#plan) and the form
// posts with no script; nothing here ships `disabled`, and nothing is
// disabled at all — an over-limit tick is simply undone.
//
// Not in packs/, for team_share.js's reason; imported by packs/application.js.

function planForm(target) {
  return target instanceof HTMLInputElement && target.type === "checkbox"
    ? target.closest("[data-team-plan]")
    : null;
}

function picked(form) {
  return [...form.querySelectorAll('input[type="checkbox"]:checked')].map((box) => box.value).sort().join(",");
}

function refresh(form, message) {
  const count = form.querySelectorAll('input[type="checkbox"]:checked').length;
  const counter = form.querySelector("[data-plan-count]");
  // The sentence is Room#plan_count_line's, with %{count} left in for us.
  if (counter && counter.dataset.planCountLine) {
    counter.textContent = counter.dataset.planCountLine.replace("%{count}", String(count));
  }

  const changed = picked(form) !== form.dataset.planSaved;
  form.classList.toggle("team-room__picker-form--unsaved", changed);
  const state = form.querySelector("[data-plan-state]");
  if (state) state.textContent = message || (changed ? form.dataset.planUnsaved : "");
}

function onChange(event) {
  const box = event.target;
  const form = planForm(box);
  if (!form) return;

  const limit = Number(form.dataset.planLimit);
  const count = form.querySelectorAll('input[type="checkbox"]:checked').length;
  if (box.checked && limit > 0 && count > limit) {
    box.checked = false;
    refresh(form, form.dataset.planFull);
    return;
  }
  refresh(form);
}

function remember() {
  document.querySelectorAll("[data-team-plan]").forEach((form) => {
    form.dataset.planSaved = picked(form);
  });
}

document.addEventListener("change", onChange);
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", remember);
} else {
  remember();
}
